import { Navigate } from 'react-router-dom';

export const PrivateRoute = ({ children }) => {
  // const auth = localStorage.getItem('x-auth-token') ? localStorage.getItem('x-auth-token') : false;
  return localStorage.getItem('x-auth-token') ? children : <Navigate to="/login" replace />;
};
